import * as React from "react"
import * as _ from "lodash"
import * as $ from "jquery"
import {IPatientVitalHistory, IPatientVitalResponse} from "./../models/IPatientVitalResponse"
import AppUtils from "./../utils/AppUtils"
import {Chart} from "react-google-charts"
import ChartComponent from "../components/ChartComponent";
import {AppMessages} from "../utils/AppConstants";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientVitalsViewProps {
    patientVitals: IPatientVitalResponse[];
}


export interface PatientVitalsViewState {
    isExpanded: boolean;
}

export const VitalsChartOptions = {
    // curveType: "function",
    pointsVisible: true,
    legend: {position: "none"},
    backgroundColor: "#f1f5f8",
    hAxis: {baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "transparent"}},
    vAxis: {baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "transparent"}}
}

export const vitalsToChart = ["BP", "TEMPERATURE"]

class VitalsChartContainer extends React.Component<PatientVitalsViewProps, PatientVitalsViewState> {

    constructor(props: PatientVitalsViewProps) {
        super(props);
        this.state = {
            isExpanded: false
        }
    }

    generateRows = (chartData: IPatientVitalHistory[]) => {
        let rowArray: any = [];
        _.map(_.reverse(chartData), (chartItem: any, index) => {
            let item = [];
            item.push(index);
            item.push(parseInt(chartItem.value));
            let hoverItem = `<div style="padding: 5px; min-width: 60px"><div style="font-size: 14px; font-weight: bold">${chartItem.value}</div><div style="font-size: 8px">${AppUtils.getRelativeDay(chartItem.recordDate, "D MMM Y", false)}</div></div>`;
            item.push(hoverItem);
            rowArray.push(item as any);
        })
        return rowArray;
    }

    generateBPRows = (chartData: IPatientVitalHistory[]) => {
        let rowArray: any = [];
        _.map(_.reverse(chartData), (chartItem: any, index) => {
            let item = [];
            let bp = chartItem.value.split("/");
            item.push(index);
            item.push(parseInt(bp[0]));
            let hoverItem = `<div style="padding: 5px; min-width: 100px"><div style="font-size: 11px;">Systolic Pressure</div><div style="font-size: 14px; font-weight: bold">${bp[0]}</div><div style="font-size: 8px">${AppUtils.getRelativeDay(chartItem.recordDate, "D MMM Y", false)}</div></div>`;
            item.push(hoverItem);
            if (!_.isEmpty(bp[1])) {
                item.push(parseInt(bp[1]));
                hoverItem = `<div style="padding: 5px; min-width: 100px"><div style="font-size: 11px;: bold">Diastolic Pressure</div><div style="font-size: 14px; font-weight: bold">${bp[1]}</div><div style="font-size: 8px">${AppUtils.getRelativeDay(chartItem.recordDate, "D MMM Y", true)}</div></div>`;
                item.push(hoverItem);
            } else {
                item.push(null);
                item.push(null);
            }
            rowArray.push(item as any);
        })
        return rowArray;
    }

    showAllVitals = () => {
        this.setState({
            isExpanded: true
        })
    }

    chartComponentCount = (): number => {
        let vitalChartsCount = 0;
        _.map(this.props.patientVitals, (vital: IPatientVitalResponse) => {
            if (vital.vitalHistoryList.length > 1) vitalChartsCount++;
        })
        return vitalChartsCount;
    }

    chartableVitals = (): IPatientVitalResponse[] => {
        let vitals: IPatientVitalResponse[] = [];
        _.map(this.props.patientVitals, (vital: IPatientVitalResponse) => {
            if (vital.vitalHistoryList.length > 1) vitals.push(vital);
        })
        return vitals;
    }

    calculateAverage = (vitalsList: IPatientVitalHistory[]): string => {
        let sum = 0;
        let count = 0;
        let average;
        _.map(vitalsList, (vital) => {
            sum = sum + parseFloat(vital.value);
            count++;
        })
        average = sum / count;
        let averageToDisplay = average % 1 === 0 ? average : average.toFixed(2);
        return averageToDisplay.toString();
    }

    calculateBPAverage = (vitalsList: IPatientVitalHistory[]): string => {
        let sum = 0;
        let count = 0;
        let average;
        _.map(vitalsList, (vital) => {
            let sp = vital.value.split("/")[0]
            if (!_.isEmpty(sp) && !isNaN(parseInt(sp))) {
                sum = sum + parseInt(sp);
                count++;
            }
        })
        average = sum / count;
        let systolicAverage = average % 1 === 0 ? average : average.toFixed(2);

        sum = 0;
        count = 0;
        _.map(vitalsList, (vital) => {
            let dp = vital.value.split("/")[1]
            if (!_.isEmpty(dp) && !isNaN(parseInt(dp))) {
                sum = sum + parseInt(dp);
                count++;
            }
        })
        average = sum / count;
        let diastolicAverage = "";
        if (!isNaN(average)) {
            diastolicAverage = average % 1 === 0 ? average.toString() : average.toFixed(2).toString();
        }

        let averageText = `SP: ${systolicAverage}, DP: ${diastolicAverage}`.toString();
        return averageText;
    }

    render() {
        let myInstance = this;
        let vitals = this.chartableVitals();
        // let vitalsToShow = this.state.isExpanded ? this.props.patientVitals : vitals.slice(0, 3);
        let vitalsToShow = this.props.patientVitals;
        let vitalChartsCount = this.chartComponentCount();
        return (
            <div className="patient-vitals-cont">
                {
                    vitals.length ?
                        _.map(vitalsToShow, function(patientVital: IPatientVitalResponse, index){
                            if (patientVital.vitalName !== "bp") {
                                let vitalUnit = !_.isEmpty(patientVital.unit) ? patientVital.unit : "";
                                let patientCurrVitalText = AppUtils.sortPatientVitalHistory(patientVital.vitalHistoryList)[0].value + " " + vitalUnit;
                                let patientAvgVitalText = patientVital.vitalName !== "bp" ? myInstance.calculateAverage(patientVital.vitalHistoryList) + " " + vitalUnit : myInstance.calculateBPAverage(patientVital.vitalHistoryList);
                                let rows = patientVital.vitalName !== "bp" ? myInstance.generateRows(patientVital.vitalHistoryList) : myInstance.generateBPRows(patientVital.vitalHistoryList);
                                if (patientVital.vitalHistoryList.length > 1) {
                                    /* vitalHistoryList is reversed before passing to ChartComponent to make sure the Line chart
                                     is rendered chronologically */
                                    return (
                                        <ChartComponent currentValue={patientCurrVitalText} averageValue={patientAvgVitalText}
                                                        rows={rows} chartName={patientVital.vitalName}
                                                        rootClass={"patient-vitals"} subClass={"vital"}
                                                        title={patientVital.vitalName.toUpperCase()} key={`chart-component-${index}`}/>)
                                }
                            }
                        }) : <div className={"no-record-found-label"}>{AppMessages.CHARTS_INSUFFICIENT_DATA}</div>
                }
                {/*{
                    !this.state.isExpanded && vitalChartsCount > 3 &&
                    <div className={"view-more-button brandon-bold"} onClick={this.showAllVitals}>VIEW ALL</div>
                }*/}
            </div>
        );
    }
}

export default VitalsChartContainer